import { SEOData } from '../services/seo.service';

export interface RouteSEOData {
  [route: string]: SEOData;
}

export const seoConfig: RouteSEOData = {
  '/home': {
    title: 'SIMVet Monitor - Veterinary Education Platform',
    description:
      'Transform veterinary education with SIMVet Monitor. Master vital signs monitoring through immersive simulations. Real-time monitoring, risk-free practice, and interactive learning for veterinary students.',
    keywords:
      'veterinary education, vital signs monitoring, clinical scenarios, animal patients, SIMVet, veterinary anesthesiology, teaching tool, educational application',
    image: '/assets/carousel/carousel1.png',
    type: 'website',
  },
  '/elearning': {
    title: 'E-Learning Platform - SIMVet Monitor',
    description:
      'Access comprehensive e-learning courses and exams on veterinary vital signs monitoring. Interactive learning modules designed for veterinary students and instructors.',
    keywords:
      'veterinary e-learning, online courses, veterinary education, exam platform, veterinary training',
    image: '/assets/images/monitor-preview.png',
    type: 'website',
  },
  '/elearning/teacher': {
    title: 'Teacher Portal - SIMVet E-Learning',
    description:
      'Create and manage courses, exams, and educational content for your veterinary students. Comprehensive tools for instructors.',
    keywords: 'veterinary teacher portal, course creation, exam management, veterinary instructors',
    image: '/assets/images/monitor-preview.png',
    type: 'website',
  },
  '/elearning/students': {
    title: 'Student Portal - SIMVet E-Learning',
    description:
      'Access your courses, take exams, and track your progress in veterinary vital signs monitoring. Student dashboard for e-learning platform.',
    keywords: 'veterinary student portal, online courses, student dashboard, veterinary exams',
    image: '/assets/images/monitor-preview.png',
    type: 'website',
  },
  '/auth/login': {
    title: 'Login - SIMVet Monitor',
    description: 'Sign in to your SIMVet Monitor account to access veterinary education tools and simulations.',
    keywords: 'SIMVet login, veterinary education login, sign in',
    noindex: true, // Don't index login pages
  },
  '/auth/register': {
    title: 'Register - SIMVet Monitor',
    description: 'Create a new account on SIMVet Monitor to start your veterinary education journey.',
    keywords: 'SIMVet register, create account, veterinary education signup',
    noindex: true, // Don't index registration pages
  },
  '/control-panel': {
    title: 'Control Panel - SIMVet Monitor',
    description: 'Configure and manage simulation scenarios for veterinary vital signs monitoring.',
    keywords: 'simulation control panel, scenario configuration, veterinary simulation',
    noindex: true, // Protected route
  },
  '/monitor': {
    title: 'Monitor - SIMVet Monitor',
    description: 'Real-time vital signs monitoring interface for veterinary simulations.',
    keywords: 'vital signs monitor, real-time monitoring, veterinary monitor',
    noindex: true, // Protected route
  },
};

export const defaultSEO: SEOData = {
  title: 'SIMVet Monitor - Veterinary Education Platform',
  description:
    'Enhance your teaching experience with our cutting-edge educational application. SIMVet allows instructors to vividly demonstrate and simulate clinical scenarios in animal patients, making vital signs monitoring engaging and effective.',
  keywords:
    'veterinary education, vital signs monitoring, clinical scenarios, animal patients, SIMVet, veterinary anesthesiology, teaching tool, educational application',
  image: '/assets/logos/simvet-light.png',
  type: 'website',
  siteName: 'SIMVet Monitor',
  twitterCard: 'summary_large_image',
};

export const organizationSchema = {
  name: 'SIMVet Monitor',
  url: 'https://simvetmonitor.com',
  logo: 'https://simvetmonitor.com/assets/logos/simvet-light.png',
  description:
    'Cutting-edge educational application for veterinary vital signs monitoring and clinical scenario simulation.',
  contactPoint: {
    contactType: 'Customer Service',
  },
};

export const websiteSchema = {
  name: 'SIMVet Monitor',
  url: 'https://simvetmonitor.com',
  description:
    'Transform veterinary education with immersive simulations for vital signs monitoring and clinical scenarios.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://simvetmonitor.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

